class Pagination {
    $onInit() {
        if (angular.isDefined(this.currentPage) && angular.isDefined(this.totalItems)) {
            this._updateFromTo();
        }
    }

    $onChanges(changesObj) {
        if (changesObj.currentPage || changesObj.totalItems) {
            if (angular.isDefined(this.currentPage) && angular.isDefined(this.totalItems)) {
                this._updateFromTo();
            }
        }
    }

    isLoaded() {
        return angular.isDefined(this.totalItems);
    }

    hasPrevPage() {
        return this.currentPage > 0;
    }

    loadPrevPage() {
        if (this.hasPrevPage()) {
            this.onPageChange({
                toPage: this.currentPage - 1,
                pageSize: this.pageSize
            });
        }
    }

    hasNextPage() {
        return (this.from + this.pageSize) <= this.totalItems;
    }

    loadNextPage() {
        if (this.hasNextPage()) {
            this.onPageChange({
                toPage: this.currentPage + 1,
                pageSize: this.pageSize
            });
        }
    }

    _updateFromTo() {
        this.from = (this.currentPage * this.pageSize) + 1;
        this.to = Math.min(this.from + (this.pageSize - 1), this.totalItems);
    }
}

export default Pagination;